import { render } from "./teaStudioList.vue?vue&type=template&id=09ee4890&scoped=true"
import script from "./teaStudioList.vue?vue&type=script&lang=js"
export * from "./teaStudioList.vue?vue&type=script&lang=js"

import "./teaStudioList.vue?vue&type=style&index=0&id=09ee4890&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ee4890"]])

export default __exports__